import { render } from "./LabelValue.vue?vue&type=template&id=75f06f09&scoped=true&ts=true&lang=pug"
import script from "./LabelValue.vue?vue&type=script&lang=ts"
export * from "./LabelValue.vue?vue&type=script&lang=ts"

import "./LabelValue.vue?vue&type=style&index=0&id=75f06f09&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75f06f09"]])

export default __exports__